import { useEffect, useRef } from 'react'
import { useWindowSize } from '@react-hookz/web'
import Player from '@vimeo/player'
import styled from 'styled-components'

import { Section } from 'bl-common/src/units/Section/Section'

const Wrap = styled.div`
  position: relative;

  > iframe {
    width: 100%;
  }
`

export const StoryVideo = ({ videoId = '372928980' }) => {
  const { width } = useWindowSize()
  const video = useRef(null)
  const player = useRef(null)

  useEffect(() => {
    const id = Number.parseInt(videoId)

    if (Number.isNaN(id)) {
      return
    }
    player.current = new Player(video.current, {
      id,
      width,
    })
  })

  return (
    <Section top={{ xs: 2, md: 3 }} bottom={{ xs: 2, md: 3 }}>
      <Wrap ref={video} />
    </Section>
  )
}
